<template>
    <div style="font-weight: initial !important; position: relative;">
        <div>
            <img style="border-radius: 43px; height: 19px; margin-top: -8px; cursor: pointer;" src="https://mcaloon.org/chat.png" />
            <span style="padding-left: 10px; color: inherit; font-size: 20px;">LifeChain Wallet</span>
        </div>

        <hr />

        <div style="text-align: center;">
            <div><b>Account</b> - Simon McAloon</div>
            <div>0x3c2...97C7</div> 
        </div>

        <hr />

        <div class="wallet-tabs" style="width: 100%; float:left">
            <b-tabs content-class="mt-3">
                <b-tab title="Assets" active>
                    <div v-if="showNFT">
                        <hr style="margin:0; border: 1px solid #DEE2E6; opacity: 0.5;"/>
                        <table style="width: 100%;">
                            <tbody>
                                <tr class="NFTsmall">
                                    <td style="padding:10px; text-align: center; padding-right: 0px; padding-left: 0px;">
                                        <img style="width: 75px;" src="../../assets/images/templateIcons/testIcons/qr-code-with-icon.png" />
                                    </td>
                                    <td style="vertical-align: top; padding: 10px; padding-left: 5px; position: relative;">
                                        NFT & AI Test Contract 2<br/>
                                        <span style="color: initial; padding-left: 0px; font-size: 12px;">(Master NFT)</span>
                                        <i style="position: absolute; top: 10px; right: 13px;" class="fa-solid fa-ellipsis-vertical"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr style="margin:0; border: 1px solid #DEE2E6; opacity: 0.5;"/>
                        <!-- <hr/> -->
                    </div>
                    <div v-else class="empty-tab">No NFT's to display</div>
                </b-tab>
                <b-tab title="Activity">
                    <div v-if="showNFT">
                        <hr style="margin:0; border: 1px solid #DEE2E6; opacity: 0.5;"/>
                        <table style="width: 100%;">
                            <tr class="NFTsmall">
                                <td style="font-size: 25px; color: #28a745; padding: 10px; padding-right: 5px;">
                                    <i class="fa-solid fa-circle-arrow-down"></i>
                                </td>
                                <td>
                                    NFT Recieved<br/>
                                    <div style="font-size: 11px;">NFT & AI Test Contract 2 (Master NFT)</div>
                                </td>
                            </tr>
                        </table>
                        <hr style="margin:0; border: 1px solid #DEE2E6; opacity: 0.5;"/>
                        <table style="width: 100%;">
                            <tr class="NFTsmall">
                                <td style="font-size: 25px; color: #007bff; padding: 10px; padding-right: 5px;">
                                    <i class="fa-solid fa-circle-plus"></i>
                                </td>
                                <td>
                                    LifeChain Created NFT<br/>
                                    <div style="font-size: 11px;">NFT & AI Test Contract 2 (Master NFT)</div>
                                </td>
                            </tr>
                        </table>
                        <hr style="margin:0; border: 1px solid #DEE2E6; opacity: 0.5;"/>
                    </div>
                    <div v-else class="empty-tab">No Transactions to display</div>
                </b-tab>
            </b-tabs>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Wallet',
        props: ['showNFT'],
        components: {
        },
        data: function () {
            return {
                test: "LifeChain Wallet",
            };
        },
        watch: {},
        methods: {      

        },
        mounted: function () {

        }
    }
</script>

<style>
    .nav-tabs .nav-item a {
        color: #007bff !important;
        padding: 8px 16px !important;
    }

    .nav-tabs .nav-item a.active {
        color: #495057 !important;
    }

    .empty-tab {
        text-align: center;
        padding-top: 93px;
        color: grey;
    }

    .NFTsmall:hover {
        background: #F5F5F5;
        cursor: pointer;
    }

</style>    

